/**
 * Boss / elite toughness-break (경직) window — EncounterKnowledge.
 * Runtime signal: `breakStunDuration > 0` on boss or elite units.
 */
import type { RaidBoss, RaidUnit } from "../raid-types";
import type { EncounterKnowledge } from "./hero-architecture";

/** True while toughness-break stun is active. */
export function unitBreakWindowOpen(
  u: Pick<RaidUnit, "breakStunDuration" | "hp">,
): boolean {
  return u.hp > 0 && u.breakStunDuration > 0;
}

export function bossBreakWindowOpen(
  boss: Pick<RaidBoss, "breakStunDuration" | "barHp">,
): boolean {
  return boss.barHp > 0 && boss.breakStunDuration > 0;
}

/**
 * Soft≪AA-safe encounter module: melt window while broken.
 * Does not change combat coeffs — RolePolicy may prefer focus during window.
 */
export const bossBreakEncounterKnowledge: EncounterKnowledge = {
  id: "boss_break_stun_window",
  enemyTags: ["elite"],
  scenarioKinds: ["bar_break"],
  windowOpen(args) {
    return args.enemies.some((e) => unitBreakWindowOpen(e));
  },
  urgency01(args) {
    if (!args.enemies.some((e) => unitBreakWindowOpen(e))) return 0;
    return 0.85;
  },
};
